import { useState } from "react";

type DataLayerEvents = "contactDetailsModal";

interface IDataLayerFunctions {
    sendPageView: (uri: string) => void;
    sendEvent: (event: DataLayerEvents) => void;
}

function useDataLayer(): IDataLayerFunctions {
    window.dataLayer = window.dataLayer || [];

    const [lastPage, setLastPage] = useState<string>();
    const sendPageView = (uri: string): void => {
        // If we go to the same page, we don't want to fire off a tracking event.
        if (uri === lastPage) return;

        window.dataLayer.push({
            event: "Pageview",
            pagePage: uri
        });
        setLastPage(uri);
    };

    const sendEvent = (event: DataLayerEvents): void => {
        window.dataLayer.push({
            event
        });
    };

    return {
        sendPageView,
        sendEvent
    };
}

export default useDataLayer;
